import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import {
  provideRouter,
  withRouterConfig,
  InMemoryScrollingOptions,
  withInMemoryScrolling,
} from '@angular/router';
import { appRoutes } from './app.routes';

import { CoreModule } from './core/core.module';

const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'disabled',
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      appRoutes,
      withInMemoryScrolling(scrollConfig),
      withRouterConfig({ paramsInheritanceStrategy: 'always' })
    ),
    importProvidersFrom(CoreModule),
  ],
};
